import { PRINTER_MODELS } from './getEnums';

type getEncondingPrinterProps = {
  model_printer: string;
  orderTxt: string;
};

const str = [
  'Á',
  'É',
  'Í',
  'Ó',
  'Ú',
  'á',
  'é',
  'í',
  'ó',
  'ú',
  'â',
  'ê',
  'î',
  'ô',
  'û',
  'à',
  'è',
  'ì',
  'ò',
  'ù',
  'Ç',
  'ç',
  'Ã',
  'Õ',
  'ã',
  'õ',
];

const rpl = [
  'A',
  'E',
  'I',
  'O',
  'U',
  'a',
  'e',
  'i',
  'o',
  'u',
  'a',
  'e',
  'i',
  'o',
  'u',
  'a',
  'e',
  'i',
  'o',
  'u',
  'C',
  'c',
  'A',
  'O',
  'a',
  'o',
];

function especialCharMask(value: string) {
  let especialChar = value;

  str.forEach((char, index) => {
    especialChar = especialChar.replaceAll(char, rpl[index]);
  });

  return especialChar;
}

export default function getEncondingPrinter({
  model_printer,
  orderTxt,
}: getEncondingPrinterProps): string {
  const buffer = new Buffer(orderTxt);
  const base64data = buffer.toString('base64');
  let base64 = `rawbt:data:text/plain;base64,${base64data}`;

  if (model_printer === PRINTER_MODELS.P_25_BLUE_BAMBOO) {
    base64 = `rawbt:base64,${btoa(orderTxt)}`;
  }

  if (model_printer === PRINTER_MODELS.MOBILE_PRINTER) {
    const orderTextParse = especialCharMask(orderTxt);
    base64 = `rawbt:data:text/plain;base64,${btoa(orderTextParse)}`;
  }

  return base64;
}
